import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const ORIGIN = BACKEND_URL;

const client = axios.create({ baseURL: API });

export const getSiteSettings = () => client.get("/site-settings").then((r) => r.data);
export const getPapers = () => client.get("/papers").then((r) => r.data);
export const getTopics = () => client.get("/topics").then((r) => r.data);
export const getWritings = () => client.get("/writings").then((r) => r.data);
export const postContact = (payload) => client.post("/contact", payload).then((r) => r.data);
